import cx from "classnames";
import React from "react";

import Badge from "../Badge";
import { TDropdownOption } from "./dropdown.type";
import icons from "@/components/icons";

const baseClassName = "c-dropdown-default-render-selected";

export interface DropdownDefaultRenderSelectedClassNames {
    icon?: string;
    header?: string
}

interface DropdownDefaultRenderSelectedProps {
    heading: string | JSX.Element;
    actionButton?: JSX.Element;
    headerIcons: {up: React.ReactNode, down: React.ReactNode};
    disabled: boolean;
    isOpen: boolean;
    selectedOption?: TDropdownOption;
    selectedOptions?: Array<TDropdownOption>;
    onSelect?: (option: TDropdownOption) => void;
    multiple?: boolean;
    classNames?: DropdownDefaultRenderSelectedClassNames;
    headerTextClassName?: string;
    search?: boolean;
}

function DropdownDefaultRenderSelected(props: DropdownDefaultRenderSelectedProps) {
    const { selectedOption, headerIcons, heading, actionButton, classNames, disabled, isOpen, headerTextClassName, selectedOptions=[], onSelect, search } = props;

    const { icon, header } = classNames;

    const renderHeaderBadge = () => {
        const opt = selectedOption;
        return opt && opt.badge && opt.badge.value > 0 ? (
            <Badge style={{ marginLeft: "16px" }} color={opt.badge.color}>
                {opt.badge.value}
            </Badge>
        ) : null;
    };


    const toggleMenuClassName = cx(
        header,
        `${baseClassName}__header`,
        { [`${baseClassName}__header--disabled`]: disabled },
        { [`${baseClassName}__header--active'`]: isOpen },
    );

    const headerTextClassNames = cx(
        { [`${baseClassName}__header-text`] : true },
        { [`${headerTextClassName}`] : !!headerTextClassName },
    );

    const renderHeaderText = () => {
        if(selectedOption){
            return selectedOption.heading;
        };
        return heading;
    }

    const renderMultipleSelectedText = () => {
        if(selectedOptions.length > 0){
            return selectedOptions.map((item) => {
                return (
                    <div onClick={(e) => {e.preventDefault(); e.stopPropagation(); onSelect(item)}} className={`${baseClassName}__multiple-selected-text`} key={item.label}>
                        {item.label}
                        <span className={`${baseClassName}__multiple-selected-icon`}>
                            {icons.CLOSEGREY}
                        </span>
                    </div>
                )
            });
        };
    }

    const renderHeadingHandler = () => {
        if(search){
            return renderHeaderText()
        }
        if(selectedOptions.length > 0){
            return renderMultipleSelectedText()
        }
        return renderHeaderText()
    }

    return <div
        className={toggleMenuClassName}
    >
        <div className={cx(
                `${baseClassName}__header-wrapper`,
                {[`${baseClassName}__header-wrapper--action`]: !!actionButton},
            )}>
            <span className={`${baseClassName}__header-container`}>
            {selectedOption && selectedOption.icon && <div className={`${baseClassName}__header-left-icon`}>
                {selectedOption.icon}
            </div>
            }

            <div className={headerTextClassNames} style={{ display: selectedOptions.length > 0 && "flex", flexFlow: selectedOptions.length > 0 && "wrap", }}>
                {/* {(selectedOptions.length > 0 || !search) ? renderMultipleSelectedText() : renderHeaderText()} */}
                {renderHeadingHandler()}
            </div>
                {renderHeaderBadge()}
            </span>
            <span className={cx(`${baseClassName}__header-icon`, icon)}>
            {isOpen ? headerIcons.up : headerIcons.down}
            </span>
        </div>
        {actionButton && <div className={`${baseClassName}__header-action`}>
            {actionButton}
        </div>}
    </div>;
}


export { DropdownDefaultRenderSelected };